import { validateEventRoutingRules, validateRoutingRules } from '../utils'
import { getAuthorization, getTicketSellerOrganization, getUserType, isTokenValid } from './../http'
import { sharedRouteNames } from './routeNames/sharedRouteNames'
import { routingUserModelTypes } from './routing-user-model-types'
import { OrganizationType } from '@/types'

export const getPropsFromParams = route => ({ ...route.params, ...route.query })

export const auth = async (to, from, next) => {
  try {
    const {
      meta: { requiresAuthentication, eventRules, rules },
      matched,
      params,
      query,
    } = to

    if (!requiresAuthentication) {
      return next()
    }

    const isValid = await isTokenValid()

    if (!isValid) {
      return next({ name: sharedRouteNames.login })
    } else {
      if (rules && rules.length > 0) {
        if (!(await validateRoutingRules(rules))) {
          const type = await getUserType()

          return next({ name: routingUserModelTypes[type].startingRoute })
        }
      }

      const requiresAuthorization = matched.some(m => m.meta && m.meta.requiresAuthorization)

      if (!requiresAuthorization) {
        return next()
      }

      const { organizationSlug, eventId, eventTemplateId } = params

      if (!organizationSlug) return next()

      const {
        isAuthorized,
        event,
        type: userType,
      } = await getAuthorization(eventId, organizationSlug, eventTemplateId)

      if (!isAuthorized) {
        return next({ path: '/' })
      }

      if (!eventId && !eventTemplateId) {
        return next()
      }

      const rulesPassed = eventRules
        ? await validateEventRoutingRules(eventRules, event, userType)
        : true

      if (!isAuthorized || !rulesPassed) {
        return next({ path: '/' })
      }

      return next()
    }
  } catch (e) {
    if (to.meta.requiresAuthentication) {
      return next({ name: sharedRouteNames.login })
    }
    return next()
  }
}

export const redirectIfAuthenticated = async (to, from, next) => {
  try {
    const {
      meta: { redirectIfAuthenticated: redirect },
    } = to

    if (!redirect) {
      return next()
    }

    const isAuthenticated = await isTokenValid()
    if (redirect && isAuthenticated) {
      const type = await getUserType()

      return next({ name: routingUserModelTypes[type].startingRoute })
    } else {
      return next()
    }
  } catch (e) {
    return next()
  }
}

export const redirectIfWrongType = async (to, from, next) => {
  try {
    if (!to.meta.requiresAuthentication) {
      return next()
    }

    const type = await getUserType()
    const ticketSellerOrganizationType = await getTicketSellerOrganization()
    if (
      !['theaterEventReport', 'register'].includes(to.name) &&
      type === 'ticketSeller' &&
      ticketSellerOrganizationType === OrganizationType.THEATER
    ) {
      window.location.replace(process.env.VUE_APP_TICKET_SELLER_URL)

      return next()
    }

    if (type && !routingUserModelTypes[type].allowedRoutes.includes(to.name)) {
      return next({ name: routingUserModelTypes[type].startingRoute })
    }

    return next()
  } catch (e) {
    return next()
  }
}
